<template>
  <div class="page-box">
    <Header />
    <LeapoAiContent />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import LeapoAiContent from './LeapoAiContent.vue'
export default {
  name: "LeapoAI",
  components: {
    Header,
    Footer,
    LeapoAiContent
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
